<template>
  <v-menu ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          :disabled="disabled"
          :rules="rulesCampo"
          v-model="dataFormatada"
          v-mask="mes ? masks.mes : masks.data"
          @blur="onBlur()"
          :label="label"
          counter="10">
        <template v-slot:prepend>
          <v-icon :disabled="disabled"
                  title="Botão para seleção de data"
                  color="teal darken-2"
                  v-bind="attrs"
                  v-on="on">
            mdi-calendar
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
        v-model="dataValue"
        @input="setData"
        no-title
        scrollable
        :min="getDataMinima"
        :max="getDataMaxima"
        :type="mes ? 'month' : 'date'"
        color="primary"
        locale="pt-br"
        class="tamanho-datepicker"/>
  </v-menu>
</template>

<script>
import Masks from "@/util/masks.util";
import Rules from "@/util/rules";

export default {
  name: "DatePickerComponent",

  data: () => ({
    dataFormatada: "",
    dataValue: "",
    rules: Rules,
    masks: Masks,
    rulesCampo: [],
    dataMinimaIso: Date,
    dataMaximaIso: Date,
    menu: false,
  }),
  props: {
    label: String,
    data: String,
    obrigatorio: Boolean,
    disabled: Boolean,
    mes: Boolean,
    dataMinima: Date,
    dataMaxima: Date,
  },
  methods: {
    onBlur() {
      this.dataValue = this.formatDateISO(this.dataFormatada);
      this.$emit("update:data", this.dataValue);
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split("-");

      if (this.mes) {
        return `${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    },
    formatDateISO(date) {
      if (!date) {
        return null;
      }
      const [day, month, year] = date.split("/");
      if (this.mes) {
        return `${month}-${day}`;
      } else {
        return `${year}-${month}-${day}`;
      }
    },
    setData() {
      this.$emit("update:data", this.dataValue);
      this.dataFormatada = this.formatDate(this.dataValue);
      this.menu = false;
    },
    validarDataMinima(value) {
      if (value) {
        if (this.rules.data(value) == true) {
          const [dia, mes, ano] = value.split("/");
          let dataInseridaCompleta = new Date(ano, mes - 1, dia);
          const [anoMinimo, mesMinimo, diaMinimo] = this.dataMinimaIso.split("-");
          let dataMinimaCompleta = new Date(anoMinimo, mesMinimo - 1, diaMinimo);
          if (dataInseridaCompleta >= dataMinimaCompleta) {
            return true;
          }
        } else {
          if (this.rules.mes(value) == true) {
            const [mes, ano] = value.split("/");
            let dataInseridaCompleta = new Date(ano, mes - 1);
            const [anoMinimo, mesMinimo] = this.dataMinimaIso.split("-");
            let dataMinimaCompleta = new Date(anoMinimo, mesMinimo - 1);
            if (dataInseridaCompleta >= dataMinimaCompleta) {
              return true;
            }
          }
        }
        return "A data não pode ser menor que a data atual!";
      } else {
        return true;
      }
    },
    validarDataMaxima(value) {
      if (value) {
        if (this.rules.data(value) == true) {
          const [dia, mes, ano] = value.split("/");
          let dataInseridaCompleta = new Date(ano, mes - 1, dia);
          const [anoMaxima, mesMaxima, diaMaxima] = this.dataMaximaIso.toString().split("-");
          let dataMaximaCompleta = new Date(anoMaxima, mesMaxima - 1, diaMaxima);
          if (dataInseridaCompleta <= dataMaximaCompleta) {
            return true;
          }
        } else {
          if (this.rules.mes(value) == true) {
            const [mes, ano] = value.split("/");
            let dataInseridaCompleta = new Date(ano, mes - 1);
            const [anoMaxima, mesMaxima] = this.dataMaximaIso.toString().split("-");
            let dataMaximaCompleta = new Date(anoMaxima, mesMaxima - 1);
            if (dataInseridaCompleta <= dataMaximaCompleta) {
              return true;
            }
          }
        }
        return "A data não pode ser maior que a data atual!";
      } else {
        return true;
      }
    },

    definirData(data) {
      if (data) {
        this.rulesCampo = [];
        if (this.mes) {
          this.rulesCampo.push(this.rules.mes);
        } else {
          this.rulesCampo.push(this.rules.data);
        }
        if (this.obrigatorio) {
          this.rulesCampo.unshift(this.rules.obrigatorio);
        }
        if (this.dataMinima && !this.disabled) {
          this.rulesCampo.push(this.validarDataMinima);
        } else if (this.dataMaxima && !this.disabled) {
          this.rulesCampo.push(this.validarDataMaxima);
        }
        this.dataValue = data;
        this.dataFormatada = this.formatDate(data);
      } else {
        if (this.obrigatorio) {
          this.rulesCampo.push(this.rules.obrigatorio);
        }
      }
    },
  },
  mounted() {
    this.definirData(this.data);
  },
  watch: {
    data: function (novo, velho) {
      if (novo !== velho) {
        this.definirData(novo);
      }
    },
  },
  computed: {
    getDataMinima() {
      if (this.dataMinima) {
        this.dataMinimaIso = this.dataMinima.toISOString().substr(0, 10);
        return this.dataMinimaIso;
      }
    },
    getDataMaxima() {
      if (this.dataMaxima) {
        this.dataMaximaIso = this.dataMaxima.toISOString().substr(0, 10);
        return this.dataMaximaIso;
      }
    },
  },
};
</script>

<style>
.tamanho-datepicker .v-date-picker-table {
  height: 290px !important;
}
</style>
